// extracted by mini-css-extract-plugin
export var actionButton = "_ww-2";
export var card = "_ww-0";
export var errorCard = "_ww-3";
export var row = "_ww-1";